import React from 'react'
import { theme } from 'theme'
import { useNewTranslation } from 'hooks/index'
import Icon from 'components/Icon/Icon'
import Button from 'components/Shared/Button/Button'
import { Formik, FormikProps, Form } from 'formik'
import TextInput from 'components/Shared/Inputs/TextInput'
import PopupInputContainer from './styles'

interface PopUpInputProps {
    className?: string
    placeHolder: string
    inputTitle: string
    popupTitle?: string
    submitText: string
    isShowCustomError?: boolean
    customErrorMessage?: string
    isWaitForResponseClose?: boolean
    validationSchema?: any
    handleSubmit: (value: any) => any
    setShowPopup: (value: any) => any
}
const PopUpInput: React.FC<PopUpInputProps> = ({
    className,
    placeHolder,
    inputTitle,
    submitText,
    setShowPopup,
    handleSubmit,
    popupTitle = null,
    isWaitForResponseClose = false,
    validationSchema = null,
    isShowCustomError = false,
    customErrorMessage = '',
}) => {
    const [newT] = useNewTranslation()
    const handleClosePopup = (e: any) => {
        if (e.target.id !== 'input-popup-bg') return
        setShowPopup(false)
    }
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                inputValues: null,
            }}
            validationSchema={validationSchema}
            onSubmit={values => {
                handleSubmit(values.inputValues)
                if (!isWaitForResponseClose) {
                    setShowPopup(false)
                }
            }}
        >
            {(formikBag: FormikProps<any>) => {
                return (
                    <PopupInputContainer>
                        <Form
                            className={className}
                            id="input-popup-bg"
                            onClick={handleClosePopup}
                            onKeyDown={e => {
                                if (Object.keys(formikBag.errors).length > 0) {
                                    return
                                }
                                if (e.key === 'Enter') {
                                    handleSubmit(formikBag.values.inputValues)
                                }
                            }}
                        >
                            <div className="input-area-outer-container">
                                <div>
                                    <div className="popup-title">
                                        <div>{popupTitle}</div>
                                        <Icon.CloseIcon
                                            style={{ fill: theme.newColors.neutral400 }}
                                            onClick={() => setShowPopup(false)}
                                        />
                                    </div>
                                    <div className="input-block">
                                        <div className="input-title">{inputTitle}</div>
                                        <TextInput name="inputValues" placeholder={placeHolder} width="100%" />
                                        {isShowCustomError && (
                                            <span className="custom-error">{customErrorMessage}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="table-button">
                                    <Button
                                        size="m"
                                        buttonType="secondary"
                                        onClick={() => setShowPopup(false)}
                                        text={newT('button.cancel', 'Cancel')}
                                    />
                                    <Button
                                        size="m"
                                        buttonType="primary"
                                        onClick={() => {
                                            formikBag.submitForm
                                        }}
                                        isDisable={
                                            formikBag.values.inputValues === null || formikBag.values.inputValues === ''
                                        }
                                        text={submitText}
                                    />
                                </div>
                            </div>
                        </Form>
                    </PopupInputContainer>
                )
            }}
        </Formik>
    )
}
export default PopUpInput
